import { LocalDate } from '@brunommsilva/react-foundations';

import TransactionType from './transaction-type-enum';

type Category = {
  id: string;
  name: string;
  icon?: string;
};

type Account = {
  id: string;
  name: string;
};

export default class Transaction {
  id: string;
  type: TransactionType;
  date: LocalDate;
  account: Account;
  otherAccount?: Account;
  amount: number;
  category: Category;
  description: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(fields: {
    id: string;
    type: TransactionType;
    date: LocalDate;
    account: Account;
    otherAccount?: Account;
    amount: number;
    category: Category;
    description: string;
    createdAt: Date;
    updatedAt: Date;
  }) {
    Object.assign(this, fields);
  }

  get displayDate(): string {
    return this.date.format();
  }
}
